import React, {useEffect, useState, useRef} from 'react';
import { SFConnection } from 'common/sf-connector';
import { useTranslation } from 'react-i18next';
import Spinner from '@salesforce/design-system-react/components/spinner';

export interface IProfileProps {
    selected ?: any [];
    onChange: (selected: any) => void;
}

export function ProfileInput({selected = ['Admin'], onChange} : IProfileProps) {
    const [profiles, setProfiles] = useState<any[]>([]);
    const [selectedProfiles, setSelectedProfiles] = useState<any[]>(selected);
    const listRef = useRef(null);
    const {t} = useTranslation();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        SFConnection.fetchProfiles().then((profiles) => {
            let profs = profiles.map(profile => {
                return {
                    id: profile.FullName,
                    label: profile.Name
                }
            });
            console.log('Profiles', profs);

            setProfiles(profs);
            setIsLoading(false);
        })
    }, []);

    function isProfileSelected(profileId: string) {
        return selected.find(sel => sel === profileId);
    }

    return <>
        <div style={{fontWeight: 'bold'}}>{
            t("task_input_permission_selected", {
                selectedList: selectedProfiles.join(', ')
            })
            }</div>
        <div className="slds-p-around_medium slds-is-relative">
            {isLoading ?
                <Spinner size="medium" variant="brand" assistiveText={{label:"Loading..."}}></Spinner>
                :
                <select className="slds-input" multiple ref={listRef} onChange={e => {
                    var result = [];
                    let select = e.target;
                    var options = select && select.options;
                    var opt;

                    for (var i=0, iLen=options.length; i<iLen; i++) {
                    opt = options[i];

                    if (opt.selected) {
                        result.push(opt.value || opt.text);
                    }
                    }
                    console.log(result);
                    setSelectedProfiles(result);
                    onChange(result);
                }}>
                    {profiles.map(profile => <option key={profile.id} value={profile.id} selected={isProfileSelected(profile.id)} >{profile.label}</option>)}
                </select>
            }
        </div>
    </>
}